// src/utils/urlHelpers.js

/**
 * Erstellt eine API-URL mit automatisch angehängtem Token
 * @param {string} path - Der API-Pfad (ohne Basis-URL)
 * @returns {string} - Vollständige URL mit Token
 */
export const getSecureUrl = (path) => {
  const token = localStorage.getItem('token');
  // Umgebungsvariable verwenden statt hartcodierter URL
  const baseUrl = process.env.REACT_APP_API_URL || '';
  
  // Path bereinigen
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  
  // Token hinzufügen, wenn vorhanden
  const separator = cleanPath.includes('?') ? '&' : '?';
  const tokenParam = token ? `${separator}token=${token}` : '';
  
  return `${baseUrl}${cleanPath}${tokenParam}`;
};

/**
 * Öffnet eine PDF-URL im neuen Tab mit korrektem Token
 * @param {number} reportId - Die Report-ID 
 */
export const openReportPdf = (reportId) => {
  const url = getSecureUrl(`/reports/${reportId}/pdf`);
  console.log('Öffne PDF-URL:', url);
  window.open(url, '_blank');
};
